// extracted by mini-css-extract-plugin
export default {"incentive":"incentive__ZW3Uw","best-seller":"best-seller__KAvaQ incentive__ZW3Uw","efficient":"efficient__UCNy6 incentive__ZW3Uw","icon":"icon__p81m0"};